































import { defineComponent, PropType } from "@nuxtjs/composition-api";

export default defineComponent({
  name: "ProductBreadcrumbs",
  props: {
    breadcrumbs: {
      type: Array as PropType<Array<{ text: string; link: string }>>,
      default: undefined,
    },
  },
  setup() {
    const normalizeUrl = (url: string) => {
      return url.replace(/%2F/g, "/");
    };

    return {
      normalizeUrl,
    };
  },
});
